var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('div',{ref:"editor",staticClass:"editor-wrapper",staticStyle:{"width":"125%"}}),_vm._v(" "),_c('p',{staticStyle:{"color":"red","text-align":"left"}},[_vm._v("\n    不能超过3000个字符\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2ee0b7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/WangEditor.vue
// module id = null
// module chunks = 